<template>
   <div class="w-100 p-3" style="height: 75vh;overflow-y: auto;">
      <div class="d-flex flex-justify-start">
         <div class="filter-left">
            <label class="text-bold">{{ $t("Event log") }}</label>
            <select class="pl-4 select text-small w-auto" v-model="logName" @change="onChangeLogName()">
               <option value="System">{{ $t("System") }}</option>
               <option value="Application">{{ $t("Application") }}</option>
               <option value="Security">{{ $t("Security") }}</option>
            </select>
         </div>
         <div class="filter-left">
            <label class="text-bold">{{ $t("Level") }}</label>
            <select class="pl-4 select  text-small w-auto" v-model="level">
               <template v-if="logName != 'Security'">
                  <option value="1">{{ $t("Errors") }}</option>
                  <option value="2">{{ $t("Warnings") }}</option>
                  <option value="4">{{ $t("Info") }}</option>
               </template>
               <template v-else>
                  <option value="8">{{ $t("Success") }}</option>
                  <option value="16">{{ $t("Failure") }}</option>
               </template>
            </select>
         </div>
         <div class="filter-left d-flex flex-align-end">
            <button @click="getEventLogs(true)" class="button secondary">{{ $t("Filter") }}</button>
         </div>

      </div>
      <div class="w-100 text-center" v-if="status == $ResultValue.Running">
         <span class="mif-spinner2 ani-spin mif-3x"></span>
      </div>
      <NoDataAvailable v-if="status == $ResultValue.SomeWarnings" :message="$t('No event available')" />
      <table v-if="status == $ResultValue.OK" class="bg-white border table compact striped pt-4">
         <thead>
            <tr>
               <th class="text-center" style="width: 200px;">{{ $t("Source") }}</th>
               <th class="text-center">{{ $t("Message") }}</th>
               <th class="text-center" style="width: 200px;">{{ $t("Date Created") }}</th>
            </tr>
         </thead>
         <tbody>
            <tr v-for="(event, index) in eventlogs" :key="index" :track-by="index">
               <td class="text-center">
                  <span class="badge inline tertiary">{{ event.source }}</span>
               </td>
               <td class="text-left">{{ event.message }}</td>
               <td class="text-center">{{ event.timeGenerated.toLocalDate() }}<br>({{ fromNow(event.timeGenerated) }})</td>
            </tr>
         </tbody>
      </table>
   </div>
</template>
<script>
import { fromNow } from '../../utils/utilitiesmodule';
import NoDataAvailable from '../utils/NoDataAvailable.vue';

export default {
   name: "EventLogs",
   components: {
      NoDataAvailable
   },
   data() {
      return {
         status: this.$ResultValue.Running,

         eventlogs: null,//socket
         level: 1,
         logName: "System"
      }
   },
   methods: {
      onChangeLogName() {

         if (this.logName == "Security" && !["8", "16"].includes(this.level)) {
            this.level = "16";//failure
         }

         if (this.logName != "Security" && !["1", "2", "4"].includes(this.level)) {
            this.level = "1";//errors
         }

      },
      getEventLogs(refresh) {

         if (refresh || this.eventlogs == null || this.eventlogs.length == 0) {
            this.status = this.$ResultValue.Running;

            this.$root.socket("GetEventLogs", this.logName, this.level).then(events => {
               if (this.eventlogs == null)
                  this.eventlogs = [];
               else
                  this.eventlogs.clear();

               this.eventlogs.update(events);

               if (this.eventlogs.length == 0) {
                  this.status = this.$ResultValue.SomeWarnings;
               } else {
                  this.status = this.$ResultValue.OK;
               }
            });
         }
      },
      fromNow(date) {
         if (date == null || date == "") return ""
         return fromNow(date, this.$moment);
      },
   }
}
</script>